/**
 * テナント
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'
 import * as types from '../../mutation-types/admin-types'

 const API_PATH = `${httpConst.ADMIN_ENDPOINT}/tenants`

 const tenant = {
  namespaced: true,
  state: {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      keyward: null
    },
  },
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    index ({ dispatch, commit, state }, { keyward, page }) {
      dispatch('saveCondition', { keyward: keyward })
      const params = { keyward: state.condition.keyward, page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.ADMIN_TENANT, { content })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { keyward }) {
      const _keyward = (keyward !== undefined) ? keyward : state.condition.keyward
      const params = { keyward: _keyward }
      commit(types.ADMIN_TENANT_CONDITION, { params })
    }
  },
  mutations: {
    [types.ADMIN_TENANT] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_TENANT_CONDITION] (state, { params }) {
      state.condition.keyward = params.keyward
    }
  },
 }

 export default tenant
